export const UrlConstants = {
  // 社名アイコンURL
  COMPANY_ICON_URL: 'page0001',

  // よくある質問（FAQ）URL
  FAQ_URL: 'page0002',

  // 約款・ご契約のしおり・特別勘定のしおり
  TERMS_AND_CONDITIONS_URL: 'page0007',

  // 商品説明ページURL
  PRODUCT_DESCRIPTION_URL: 'page0008',

  // ご契約者専用サイトURL
  CONTRACTORS_ONLY_SITE_URL: 'page0009',

  // 解説動画URL
  COMMENTARY_VIDEO_URL: 'page0010',
};
